export enum CUSTOMERMODE {
  'PRIV'= 'PRIV', // Privatkunde
  'GEWE'= 'GEWE' // Gewerbekunde
}
